import { mapGetters } from 'vuex'
export const settings = {
  computed: {
    ...mapGetters('settings', [
      'countries'
    ])
  },
  methods: {
    /* ...mapActions('settings', [
      'loadCountries'
    ]), */
    getSettings (basePlan, baseModel, countries, channels, usdPerMarketing, mediaLinks) {
      // minWeeklySpend
      let minWeeklySpend = {}
      // Load settings for minWeeklySpend
      if (basePlan && basePlan.settings && basePlan.settings.minWeeklySpend) {
        // minWeeklySpend settings defined at plan level
        minWeeklySpend = Object.assign({}, basePlan.settings.minWeeklySpend)
      } else if (baseModel) {
        if (baseModel.settings && baseModel.settings.minWeeklySpend) {
          // minWeeklySpend settings defined at model instance level
          minWeeklySpend = Object.assign({}, baseModel.settings.minWeeklySpend)
        } else if (baseModel.reference_model && baseModel.reference_model.config && baseModel.reference_model.config.settings && baseModel.reference_model.config.settings.min_weekly_spend) {
          // minWeeklySpend settings defined at model reference level
          minWeeklySpend = Object.assign({}, baseModel.reference_model.config.settings.min_weekly_spend)
        } else {
          // When no settings are defined at Plan or Model level, try to use global country settings
          if (countries && countries.length > 0) {
            if (baseModel.custom_model && baseModel.custom_model.country && baseModel.type === 'ekrm') {
              // EKRM
              const country = countries.filter(item => {
                return item.id === baseModel.custom_model.country
              })
              if (country.length === 1 && country[0].weekly_minimum_spend) {
                // Min weekly spend for the country across all channels
                const minWeeklySpendCountry = Math.min(...Object.values(countries[0].weekly_minimum_spend))
                for (const channel of channels) {
                  const strippedName = channel[0].toLowerCase().replaceAll(' ', '')
                  if (country[0].weekly_minimum_spend[strippedName]) {
                    minWeeklySpend[channel[0]] = Math.floor(country[0].weekly_minimum_spend[strippedName] / usdPerMarketing)
                  } else {
                    minWeeklySpend[channel[0]] = Math.floor(minWeeklySpendCountry / usdPerMarketing)
                  }
                }
              }
            } else {
              let country
              if (baseModel.custom_model && baseModel.custom_model.country && baseModel.type === 'custom' && mediaLinks) {
                // Reference Model
                country = countries.filter(item => {
                  return item.id === baseModel.custom_model.country
                })
              } else if (baseModel.type === 'mmm' && baseModel.reference_model && baseModel.reference_model.config && baseModel.reference_model.config.brands && Object.keys(baseModel.reference_model.config.brands).length > 0 && baseModel.reference_model.config.brands[Object.keys(baseModel.reference_model.config.brands)[0]].country && mediaLinks) {
                // Ad-Hoc
                country = countries.filter(item => {
                  return item.id === baseModel.reference_model.config.brands[Object.keys(baseModel.reference_model.config.brands)[0]].country
                })
              } else {
                return false
              }
              if (country.length === 1 && country[0].weekly_minimum_spend) {
                const minWeeklySpendCountry = Math.min(...Object.values(countries[0].weekly_minimum_spend))
                for (const channel of channels) {
                  // Map pretty names to media links, using mediaLinks, and populate minWeeklySpend accordingly
                  const mediaLinkName = mediaLinks[channel[0]] ? mediaLinks[channel[0]] : false
                  minWeeklySpend[channel[0]] = mediaLinkName && country[0].weekly_minimum_spend[mediaLinkName] ? Math.floor(country[0].weekly_minimum_spend[mediaLinkName] / usdPerMarketing) : Math.floor(minWeeklySpendCountry / usdPerMarketing)
                }
              }
            }
          } else {
            return false
          }
        }
      } else {
        // No baseModel
        console.error('No baseModel')
        return false
      }
      // If other settings are defined, they should be checked for here too and managed properly
      if (minWeeklySpend && Object.keys(minWeeklySpend).length > 0) {
        return {
          minWeeklySpend: minWeeklySpend
        }
      } else {
        return false
      }
    }
  }
}
